module.exports = __webpack_public_path__ + "static/onsean_transparent-3bf9e2fe2ac601b9cd8345d3c5732b38.png";